import { createContext, useContext, useState, ReactNode } from 'react';

interface EntityContextType {
  entityName: string;
  setEntityName: (name: string) => void;
}

const EntityContext = createContext<EntityContextType | undefined>(undefined);

// Valor por defecto: la primera entidad de la lista
const DEFAULT_ENTITY_NAME = "Nom de l'Entitat 1";

export function EntityProvider({ children }: { children: ReactNode }) {
  const [entityName, setEntityName] = useState<string>(DEFAULT_ENTITY_NAME);

  return (
    <EntityContext.Provider value={{ entityName, setEntityName }}>
      {children}
    </EntityContext.Provider>
  );
}

export function useEntity() {
  const context = useContext(EntityContext);
  if (context === undefined) {
    throw new Error('useEntity must be used within an EntityProvider');
  }
  return context;
}
